<template>
    <el-header class="my-area">
        <el-row class="my-header">
            <!--头像-->
            <el-col :span="4" class="my-header-left">
                <router-link to="/" class="my-title">
                    <img src="../../assets/img/logo.png"/>
                </router-link>
            </el-col>

            <el-col v-if="!simple" :span="16">
                <!--
                :router=true
                是否使用vue-router的模式，
                启用该模式会在激活导航时以 index 作为 path 进行路由跳转-->
                <el-menu :router=true
                         menu-trigger="click"
                         active-text-color="#00fff5"
                         text-color="rgba(255,255,255,0.8)"
                         :default-active="activeIndex"
                         mode="horizontal">
                    <el-menu-item index="/blog">
                        <i class="el-icon-tickets"></i>首页
                    </el-menu-item>

                    <el-menu-item index="/category/all">
                        <i class="el-icon-s-order"></i>文章分类
                    </el-menu-item>

                    <el-menu-item index="/tag/all">
                        <i class="el-icon-price-tag"></i>标签
                    </el-menu-item>

                    <el-menu-item index="/archives">
                        <i class="el-icon-chat-line-square"></i>文章归档
                    </el-menu-item>

                    <!--offset可以指定偏移数-->
                    <el-col :span="4" :offset="4">
                        <el-menu-item index="/write">
                            <i class="el-icon-edit"></i>写文章
                        </el-menu-item>
                    </el-col>

                </el-menu>
            </el-col>

            <template v-else>
                <slot></slot>
            </template>

            <el-col :span="4">
                <el-menu :router=true
                         menu-trigger="click"
                         mode="horizontal"
                         text-color="rgba(255,255,255,0.8)"
                         active-text-color="#00fff5">
                    <template v-if="!user.login">
                        <el-menu-item index="/login">
                            <el-button type="text">登录</el-button>
                        </el-menu-item>
                        <el-menu-item index="/register">
                            <el-button type="text">注册</el-button>
                        </el-menu-item>
                    </template>

                    <template v-else>
                        <el-submenu index class="header-user-submenu">
                            <template slot="title">
                                <span class="my-header-avatar-wrap">
                                    <img class="my-header-picture" :src="avatarSrc" alt="" @error="onAvatarError"/>
                                </span>
                            </template>
                            <el-menu-item index @click="logout"><i class="el-icon-back"></i>退出</el-menu-item>
                        </el-submenu>
                    </template>

                </el-menu>
            </el-col>

        </el-row>
    </el-header>
</template>

<script>
    import defaultAvatar from '@/assets/img/default_avatar.png'
    import staticUserAvatar from '@/assets/img/avatar-fee07e00.jpg'

    // const DEFAULT_AVATAR = 'http://qiniuyun.suqiqaq.cn/2e37460b-1d38-48a7-9b25-eecc70e556f1.jpg';
    const DEFAULT_AVATAR = defaultAvatar;
    const STATIC_QINIU_AVATAR = staticUserAvatar;

    export default {
        name: 'BaseHeader',
        props: {
            activeIndex: String,
            simple: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            user() {
                let login = this.$store.state.phoneNumber.length !== 0;
                let avatar = this.$store.state.avatar;
                return {
                    login, avatar
                }
            },
            avatarSrc() {
                let avatar = this.$store.state.avatar;
                if (!avatar || typeof avatar !== 'string' || avatar.trim() === '') {
                    return DEFAULT_AVATAR;
                }
                avatar = avatar.trim();
                if (
                    (avatar.startsWith('http://qiniuyun.suqiqaq.cn/') || avatar.startsWith('https://qiniuyun.suqiqaq.cn/')) &&
                    avatar.indexOf('/fee07e00-0139-4cf4-a248-7d044a602399.jpg') !== -1
                ) {
                    // Keep the old Qiniu avatar URL available in data, but render the bundled static image to avoid certificate/load failures.
                    return STATIC_QINIU_AVATAR;
                }
                if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
                    return avatar;
                }
                const base = process.env.VUE_APP_BASE_API || '';
                return base ? (base.replace(/\/$/, '') + (avatar.startsWith('/') ? avatar : '/' + avatar)) : avatar;
            }
        },
        methods: {
            onAvatarError(e) {
                if (e.target.dataset.fallbackApplied === 'true') {
                    return;
                }
                e.target.dataset.fallbackApplied = 'true';
                e.target.src = DEFAULT_AVATAR;
            },
            logout() {
                this.$store.dispatch("logout").then(() => {
                    this.$router.push({path: "/login"});
                    this.$message({message: "已退出账户，请重新登录", type: "success", showClose: true});
                }).catch((error) => {
                    this.$message({message: error, type: "error", showClose: true});
                })
            },
        }
    }

</script>

<style>
    /* 赛博朋克玻璃风导航 */
    .el-header {
        background: rgba(10, 15, 30, 0.75);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        position: fixed;
        z-index: 1024;
        min-width: 100%;
        border-bottom: 1px solid rgba(0, 255, 245, 0.25);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4), 0 0 20px rgba(0, 255, 245, 0.05);
    }

    .el-button {
        color: rgba(0, 255, 245, 0.9) !important;
    }
    .el-button:hover {
        color: #00fff5 !important;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.6);
    }

    .my-title {
        margin-top: 10px;
        font-size: 24px;
    }
    .my-header-left {
        margin-top: 10px;
    }
    .my-title img {
        max-height: 2.5rem;
        max-width: 100%;
        filter: drop-shadow(0 0 8px rgba(0, 255, 245, 0.4));
    }

    .el-menu {
        background: transparent !important;
        border-bottom: none !important;
    }
    .el-menu-item {
        color: rgba(255, 255, 255, 0.8) !important;
        transition: all 0.25s ease;
    }
    .el-menu-item:hover {
        color: #00fff5 !important;
        background: rgba(0, 255, 245, 0.06) !important;
        text-shadow: 0 0 12px rgba(0, 255, 245, 0.4);
    }
    .el-menu-item.is-active {
        color: #00fff5 !important;
        text-shadow: 0 0 12px rgba(0, 255, 245, 0.6), 0 0 24px rgba(0, 255, 245, 0.25);
        border-bottom: 2px solid #00fff5 !important;
        box-shadow: 0 2px 0 0 rgba(0, 255, 245, 0.15);
    }
    .my-header .el-menu-item:focus,
    .my-header .el-menu-item:active,
    .my-header .el-menu-item.is-active,
    .my-header .el-menu-item.is-active:focus,
    .my-header .el-menu-item.is-active:active {
        color: #00fff5 !important;
        background: rgba(0, 255, 245, 0.06) !important;
        text-shadow: 0 0 12px rgba(0, 255, 245, 0.6), 0 0 24px rgba(0, 255, 245, 0.25);
        border-bottom: 2px solid #00fff5 !important;
        outline: none !important;
    }
    .my-header .el-menu-item:focus i,
    .my-header .el-menu-item:active i,
    .my-header .el-menu-item.is-active i,
    .my-header .el-menu-item.is-active:focus i,
    .my-header .el-menu-item.is-active:active i {
        color: #00fff5 !important;
    }
    .el-menu-item i {
        color: inherit;
    }

    /* 科技风头像外圈：霓虹环 + 毛玻璃 */
    .my-header-avatar-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        padding: 2px;
        background: linear-gradient(135deg, rgba(0, 255, 245, 0.5), rgba(236, 72, 153, 0.35));
        box-shadow:
            0 0 16px rgba(0, 255, 245, 0.4),
            0 0 32px rgba(0, 255, 245, 0.15),
            inset 0 0 20px rgba(0, 255, 245, 0.08);
        transition: all 0.3s ease;
    }

    .my-header-avatar-wrap:hover {
        box-shadow:
            0 0 24px rgba(0, 255, 245, 0.6),
            0 0 40px rgba(236, 72, 153, 0.25),
            inset 0 0 24px rgba(0, 255, 245, 0.1);
        transform: scale(1.05);
    }

    .my-header-picture {
        width: 36px;
        height: 36px;
        min-width: 36px;
        min-height: 36px;
        max-width: 36px;
        max-height: 36px;
        object-fit: cover;
        border-radius: 50%;
        border: 1px solid rgba(10, 15, 30, 0.6);
        vertical-align: middle;
        background: rgba(10, 15, 28, 0.5);
        box-shadow: inset 0 0 12px rgba(0, 0, 0, 0.3);
    }

    .header-user-submenu .el-submenu__title {
        padding-left: 8px;
        padding-right: 12px;
    }

    /* 与首页导航栏 hover 一致：青色高亮，不用白色 */
    .header-user-submenu .el-submenu__title:hover {
        color: #00fff5 !important;
        background: rgba(0, 255, 245, 0.06) !important;
        text-shadow: 0 0 12px rgba(0, 255, 245, 0.4);
    }
    .header-user-submenu .el-submenu__title:focus {
        color: #00fff5 !important;
        background: rgba(0, 255, 245, 0.06) !important;
        outline: none !important;
    }

    .header-user-submenu .el-submenu__title:hover .my-header-avatar-wrap {
        box-shadow:
            0 0 24px rgba(0, 255, 245, 0.6),
            0 0 40px rgba(236, 72, 153, 0.25),
            inset 0 0 24px rgba(0, 255, 245, 0.1);
    }

    .el-submenu__title {
        color: rgba(255, 255, 255, 0.8) !important;
    }

    .header-user-submenu .el-submenu__icon-arrow {
        color: rgba(0, 255, 245, 0.9) !important;
    }

    .header-user-submenu:hover .el-submenu__icon-arrow {
        color: #00fff5 !important;
        text-shadow: 0 0 8px rgba(0, 255, 245, 0.5);
    }
    /* 头像下拉（含退出）：默认深色不白，移入青色高亮 */
    .el-menu--popup {
        background: rgba(10, 15, 30, 0.9) !important;
        backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2) !important;
        box-shadow: 0 0 30px rgba(0, 255, 245, 0.1);
    }
    .el-menu--popup li,
    .el-menu--popup .el-menu-item {
        background: transparent !important;
        color: rgba(255, 255, 255, 0.85) !important;
        transition: all 0.25s ease;
    }
    .el-menu--popup li:hover .el-menu-item,
    .el-menu--popup .el-menu-item:hover,
    .el-menu--popup .el-menu-item:focus,
    .el-menu--popup .el-menu-item:active {
        color: #00fff5 !important;
        background: rgba(0, 255, 245, 0.08) !important;
        text-shadow: 0 0 12px rgba(0, 255, 245, 0.4);
        outline: none !important;
    }
    .el-menu--popup li:hover {
        background: rgba(0, 255, 245, 0.08) !important;
    }
    .el-menu--popup .el-menu-item:hover i,
    .el-menu--popup .el-menu-item:focus i,
    .el-menu--popup .el-menu-item:active i {
        color: #00fff5 !important;
    }
</style>
